<template>
<div class="chapter">
<div class="inner_page">
<h1 class="chapter-number"><a id="page-1"></a><a href="#/toc#toc-chapter002">1</a></h1>
<h1 class="chapter-title"><a href="#/toc#toc-chapter002"></a></h1>
<p class="noindent"><span class="dropcap">T</span>he man gazed down at the body stretched before him. She’d been a pretty thing. A bit scrawny, perhaps, but with the makeup removed and her face in sleep’s repose, she had the bare, otherworldly look of an angel.</p>
<p>Then again, he always saw his brides that way. Sisters of Mercy. Chaste, docile, patiently awaiting the intimate piercing that would join them forever.</p>
<p>He stroked her arm, caressing the limb from the shoulder all the way down to the wrist, watching the play of vein and artery
below the soft skin. The sight thrilled him—as much for its own sake as for what he knew was coming.
</p>
<p>He tried to prolong the moment, to control his breathing and the rising excitement. Before he’d learned to have power over
his impulses, he’d squandered the precious fluid. Even now he could wait only a few seconds. Compelled, he found the blue
vein still pulsing in her arm, gently, carefully squeezed the needle in, and began the ritual. As the bags filled with the
deep claret blood, his heart filled with a fevered, zealous devotion. In that moment, <a id="page-2"></a>he would have done almost anything for the creature in front of him.
</p>
<p>He crooned a soft hymn as he drained her. Brushed the hair back from her pale, pale skin. Sweet child. Sweet, sacred child.</p>
<p>There would always be things in this world that could not be explained. Just as there would always be people who tried to
explain them. A bad childhood. A bad set of genes. God’s will. He smiled. Or the Devil’s.
</p>
<p>But the fact was, the most important things had no explanation. Life and death were true mysteries.</p>
<p>But as humans, we weren’t just empty bottles whipped down the road by the wind. We could take action. We could spurt seed
into a fertile womb or steal air from healthy lungs.
</p>
<p>In this way we became the myth ourselves. The Creator. The Destroyer. The One Who Acts.</p>
<p>Not because we hate or love, but because we can.</p>
<p>There was no better reason for doing what he did.</p>
<p>Because he could. Like God, the ultimate actor.</p>
<p>Just as it has pleased God throughout the ages to slaughter the innocent, it pleased him to watch the life seep out of his
silent sacrifice.
</p>
<p>When it was done, and her heart had stopped, he secured her gift in the cooler, dating it carefully.</p>
<p>Then he kissed her serene forehead and her bloodless lips, picked up the blade, and carved out her eyes.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chapter002.vue?7f668a82